import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertPower',
    standalone: false
})
export class ConvertPowerPipe implements PipeTransform {

  transform(value: any, unit?: string, module?: string): any {
    /* This was created because in some modules, the values came from backend
    in Wh and in another ones, are in MWh */
    if (module === 'check_revenues') {
      if (unit) {
        if (typeof value === 'string') {
          value = parseFloat(value);
        }
        switch (unit) {
          case 'GW':
            return value / 1000;
          default:
            return value;
        }
      }
    } else {
      if (unit) {
        switch (unit) {
          case 'kW':
            return value / 1000;
          case 'MW':
            return value / 1000000;
          default:
            return value;
        }
      }
      return value;
    }
  }
}


